
export default {
  load() {
    const roomcashCopyButtons =document.getElementsByClassName('roomcashReferralLinkContainer')

    for(const roomcashCopyButton of roomcashCopyButtons){

      roomcashCopyButton.addEventListener('click',  async ()=>{
        const copyText = document.getElementById('roomcashReferralLink')
        navigator.permissions.query({name: 'clipboard-write'}).then(result => {
          const copiedText = Array.from(roomcashCopyButton.children).find( child => {
            return child.classList.contains('clipboard-click-text')
          })
          roomcashCopyButton.classList.add('copied')
          if (result.state == 'granted' || result.state == 'prompt') {
            navigator.clipboard.writeText(copyText.innerText).then( () => {
              copiedText.innerText = 'Copied!'
            })
          } else {
            copiedText.innerText = 'Failed to copy'
          }
        })
      }
      )
    }
  }
}
